import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Seo, { breadcrumbJsonLd } from '../components/Seo.jsx';
import { BlogHero, PostGrid, LoadMore } from '../components/blog/BlogParts.jsx';
import { blogApi, imageUrl, PATHS } from '../lib/opinly';
import { usePosts } from './Blog.jsx';

export default function BlogCategory({ kind = 'category' }) {
  const { slug } = useParams();
  const { posts, hasMore, loading, error, loadMore, retry } = usePosts(kind === 'tag' ? { tag: slug } : { category: slug });
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (kind !== 'category') { setMeta(null); return; }
    blogApi.categories().then((cats) => setMeta(cats.find((c) => c.slug === slug) || null)).catch(() => setMeta(null));
  }, [slug, kind]);

  const fallback = posts[0]?.[kind === 'tag' ? 'tags' : 'category'];
  const name = meta?.title || (kind === 'tag' ? fallback?.find?.((t) => t.slug === slug)?.name : fallback?.name) || slug.replace(/-/g, ' ');
  const description = meta?.description || (kind === 'tag' ? `Alle Beiträge zum Thema „${name}“.` : fallback?.description || `Alle Beiträge in der Kategorie „${name}“.`);
  const path = kind === 'tag' ? PATHS.tag(slug) : PATHS.category(slug);
  const label = kind === 'tag' ? 'Thema' : 'Kategorie';

  return (
    <div>
      <Seo title={`${name} – Blog`} description={description} image={imageUrl(meta?.imageUrl)} path={path}
        jsonLd={[breadcrumbJsonLd([{ name: 'Startseite', path: '/' }, { name: 'Blog', path: PATHS.index }, { name, path }]), { '@context': 'https://schema.org', '@type': 'CollectionPage', name, description, url: `${window.location.origin}${path}` }]} />
      <BlogHero eyebrow={label} title={name} description={description} crumbs={[{ name: 'Startseite', path: '/' }, { name: 'Blog', path: PATHS.index }, { name }]} />
      <section className="py-14 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <PostGrid posts={posts} loading={loading} error={error} onRetry={retry} emptyText={`In „${name}“ gibt es noch keine Beiträge.`} />
          <LoadMore hasMore={hasMore} loading={loading} onClick={loadMore} />
        </div>
      </section>
    </div>
  );
}
